import moment from 'moment';

export const returnHourString = (time: string | undefined) =>
  moment(time).isValid() ? moment(time).format('HH:mm') : '';
